module.exports = __webpack_public_path__ + "img/TruPath-10.06e7f7c2.jpg";